import { render } from "./DeletePalette.vue?vue&type=template&id=1fa57b22&scoped=true"
import script from "./DeletePalette.vue?vue&type=script&lang=js"
export * from "./DeletePalette.vue?vue&type=script&lang=js"

import "./DeletePalette.vue?vue&type=style&index=0&id=1fa57b22&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa57b22"]])

export default __exports__